
import { call, put, takeEvery } from "redux-saga/effects";
import { tietThiApi } from "../../../api/tct/tietThiApi";
import { IIdsRequest } from "../../../model/request/IIdsRequest";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { ITietThi } from "../../../model/respone/tct/ITietThi";
import { eTietThiActionIds, ITietThiActionTypes } from "../../action-types/tct/ITietThiActions";
import { rootActions } from "../../actions/rootActions";
const mainAction = rootActions.toChucThi.tietThi;
export function* tietThiSaga(): any {
    yield takeEvery(eTietThiActionIds.LOAD_START, loadWorker)
    yield takeEvery(eTietThiActionIds.SAVE_START, saveWorker)
    yield takeEvery(eTietThiActionIds.DELETE_START, deleteWorker)
}

function* loadWorker(action: ITietThiActionTypes): any {
    const res: IBaseRespone = yield call(tietThiApi.SelectAll)
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(res.data))
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi"))
    }
}

function* saveWorker(action: ITietThiActionTypes): any {
    let res: IBaseRespone;
    const payload = action.payload as ITietThi
    if (payload.id > 0) {
        res = yield call(tietThiApi.Update, payload)
    } else {
        res = yield call(tietThiApi.Insert, payload)
    }
    if (res.is_success) {
        yield put(mainAction.SAVE_SUCCESS(res.data))
    } else {
        yield put(mainAction.SAVE_ERROR(res.message ?? "Có lỗi"))
    }
}

function* deleteWorker(action: ITietThiActionTypes): any {
    const res: IBaseRespone = yield call(tietThiApi.Deletes, action.payload as IIdsRequest)
    if (res.is_success) {
        yield put(mainAction.DELETE_SUCCESS(res.data))
    } else {
        yield put(mainAction.DELETE_ERROR(res.message ?? "Có lỗi"))
    }
}